import { ApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';


export interface NotifyTeachersState extends ApiState {
  success?: boolean
}

export default requestReducer<NotifyTeachersState>('NOTIFY_TEACHERS')
